module.exports = __webpack_public_path__ + "img/vi_vn.34e4d6ab.png";